export default "__VITE_PUBLIC_ASSET__b8e530c9__"